module.exports = __webpack_public_path__ + "media/icons/message2-21742875.png";